import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { analyticsFEA } from "src/AnalyticsFEA";
import CreditRatingStepWizard from "src/components/CreditRatingStepWizard";
import { patchDealPerson } from "src/store/dataService/actions/deal";
import { hasSoftCreditIntegration } from "src/store/selectors/account";
import { getIsCreditSliderEnabled } from "src/store/selectors/electricSettings";
import { getCreditScore } from "src/store/selectors/person";
import { getVehiclesArrayForFEA } from "src/store/selectors/vehicles";
import { createClassNames } from "src/utils/classNames";
import { ApplicationStore } from "Types/state";
import CalculatorRow from "../CalculatorRow";
import CreditRating from "./Sliders/CreditRating";

const c = createClassNames("CalculatorRow__slider");

interface Props {
    isDrawer?: boolean;
}

const CreditRatingRow = ({
    vehicles,
    uuid,
    creditRating,
    updateDealPerson,
    showCreditRatingForm,
    isViewingSoftCreditRatingForm,
    isCreditSliderEnabled,
    isDrawer = false,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();
    const [showCreditRatingSlider, setShowSlider] = useState(!isViewingSoftCreditRatingForm);
    const [hasAppliedCreditRating, setAppliedCreditRating] = useState(false);

    const handleUpdateSlider = (score: number) => {
        updateDealPerson(uuid, {
            credit_estimate: score,
        });

        analyticsFEA.engine.calculationStart(uuid, vehicles);
    };

    const handleApplyCreditRating = (score: number) => {
        setShowSlider(true);
        setAppliedCreditRating(true);
        handleUpdateSlider(score);
    };

    if (!isCreditSliderEnabled) {
        return null;
    }

    return (
        <CalculatorRow
            title={t("CustomizePayment.PaymentFields.creditRating")}
            className={c(["", isDrawer && "bottom"])}
        >
            {showCreditRatingSlider && <CreditRating creditRating={creditRating} onChangeSlider={handleUpdateSlider} />}
            {showCreditRatingForm && !hasAppliedCreditRating && (
                <div className="CalculatorRow__creditForm">
                    <CreditRatingStepWizard
                        isDrawer={isDrawer}
                        setShowSlider={setShowSlider}
                        applyCreditRating={handleApplyCreditRating}
                    />
                </div>
            )}
        </CalculatorRow>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    vehicles: getVehiclesArrayForFEA(state),
    uuid: state.deal.uuid!,
    creditRating: getCreditScore(state),
    showCreditRatingForm: hasSoftCreditIntegration(state),
    isViewingSoftCreditRatingForm: state.onlineShopper.isViewingSoftCreditRatingForm,
    isCreditSliderEnabled: getIsCreditSliderEnabled(state),
});

const mapDispatchToProps = {
    updateDealPerson: patchDealPerson,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditRatingRow);
